import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import countries from "world-countries";
import { MultiSelect } from "react-multi-select-component";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ApiService from "../../services/ApiService.js";
import { toast } from "react-toastify";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import flag from "../../assets/images/UAE flag.jpeg";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import AuthTalentGuard from "../../components/AuthTalentGuard.jsx";
import { bankOptions } from "./uae_banks.js";
import languageOptions from "./languageOptions.js";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
const Arrow = () => <span className="inter-font text-muted">→</span>;
const Step = ({ children, active }) => (
  <div
    className={`inter-font rounded-circle d-flex num-circle align-items-center justify-content-center fw-bold ${
      active ? "bg-dark text-white" : "bg-light text-muted"
    }`}
    style={{ width: "30px", height: "30px", fontSize: "14px" }}
  >
    {children}
  </div>
);
const TalentRegistration = ({ onSwitchToLogin }) => {
  const [currentStage, setCurrentStage] = useState(1);
  const totalStages = 3;
  const [nationalityOptions, setNationalityOptions] = useState([]);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await ApiService.request({
          method: "GET",
          url: "/getCountries",
          headers: {
            Accept: "application/json",
            Language: "en",
          },
        });

        const countries = response?.data?.data?.countries || [];

        const formattedOptions = countries.map((country) => ({
          label: i18n.language === "ar" ? country.title_ar : country.title,
          value: country.title,
          flag: country.flag,
          nationality: country.nationality,
        }));

        setNationalityOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);
  // Custom Option component
  const Option = (props) => (
    <components.Option {...props}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img
          src={props.data.flag}
          alt={props.data.label}
          width="24"
          height="16"
          style={{ borderRadius: "3px" }}
        />
        <span>{props.data.label}</span>
      </div>
    </components.Option>
  );

  // Custom SingleValue component (selected value)
  const SingleValue = (props) => (
    <components.SingleValue {...props}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={props.data.flag}
          alt={props.data.label}
          width="24"
          height="16"
          style={{}}
        />
        <span>{props.data.label}</span>
      </div>
    </components.SingleValue>
  );


  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#f8f8f8",
      border: "1px solid #ddd",
      borderRadius: "8px",
      padding: "4px 8px",
      minHeight: "44px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#ccc",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#E26A52"
        : state.isFocused
          ? "#f5f5f5"
          : "white",
      color: state.isSelected ? "white" : "black",
      "&:hover": {
        backgroundColor: state.isSelected ? "#E26A52" : "#f5f5f5",
      },
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#E26A52",
      color: "white",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "white",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "white",
      "&:hover": {
        backgroundColor: "#d15a42",
        color: "white",
      },
    }),
  };
  const [age, setAge] = useState(null);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    phone: "",
    country: "",
    terms: false,
    nationality: "",
    dob: "",
    height: "",
    weight: "",
    languages: [],
    social_links: "",
    picture: null,
    emirates_id_document: null,
    passport: null,
    iban_certificate: null,
    bank_details: "",
    iban_number: "",
    account_holder: "",
    parents_data: {
      name: "",
      phone: "",
      emirates_id_document: null,
      passport: null,
    },
    category: "",
    subcategory: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await ApiService.request({
          method: "GET",
          url: "/getSkills",
          headers: { Accept: "application/json" },
        });

        const skills = response?.data?.data.skills || [];
        const formattedOptions = skills.map((skill) => ({
          label: i18n.language === "ar" ? skill.title_ar : skill.title,
          value: skill._id,
        }));

        setCategoryOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  // Fetch subcategories whenever selectedCategory changes
  useEffect(() => {
    if (!selectedCategory) {
      setSubcategoryOptions([]);
      setSelectedSubcategory(null);
      return;
    }

    const fetchSubcategories = async () => {
      try {
        const response = await ApiService.request({
          method: "GET",
          url: `/getSubSkills?skill_id=${selectedCategory.value}`,
          headers: {
            Accept: "application/json",
          },
        });

        const subcategories = response?.data?.data?.skills || [];
        const formattedSubOptions = subcategories.map((sub) => ({
          label: i18n.language === "ar" ? sub.title_ar : sub.title,
          value: sub._id,
        }));

        setSubcategoryOptions(formattedSubOptions);
        setSelectedSubcategory(null); // Reset previous selection
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    };

    fetchSubcategories();
  }, [selectedCategory]);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const validationRules = {
    1: [
      "first_name",
      "last_name",
      "email",
      "password",
      "phone",
      "dob",
      "country",
    ],
    2: ["height", "weight", "passport", "emirates_id_document"],
    3: ["account_holder", "iban_number"],
  };

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };
  const mappedBankOptions = bankOptions.map((bank) => ({
    label: bank.name,
    value: bank.short,
  }));
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    // Special handling for file uploads
    if (type === "file") {
      const file = files[0];
      if (file) {
        const isImageField = name === "picture";
        const allowedTypes = isImageField
          ? ["image/jpeg", "image/png", "image/webp", "image/jpg"]
          : [
              "image/jpeg",
              "image/png",
              "image/webp",
              "image/jpg",
              "application/pdf",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ];

        if (!allowedTypes.includes(file.type)) {
          toast.error(
            `Invalid file type. Supported formats: ${isImageField ? "JPG, JPEG, PNG, WEBP" : "JPG, JPEG, PNG, WEBP, PDF, DOC, DOCX"}`,
          );
          e.target.value = "";
          return;
        }

        if (file.size > 5 * 1024 * 1024) {
          toast.error("File size exceeds 5MB limit.");
          e.target.value = "";
          return;
        }
      }

      if (name.startsWith("parents_data.")) {
        const key = name.split(".")[1];
        setFormData((prev) => ({
          ...prev,
          parents_data: {
            ...prev.parents_data,
            [key]: files[0],
          },
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [name]: files[0],
        }));
      }
      return;
    }

    // ✅ Special handling for phone fields
    if (name === "phone") {
      const cleaned = value.replace(/[^0-9]/g, ""); // Keep only digits
      setFormData((prev) => ({
        ...prev,
        [name]: cleaned,
      }));
      return;
    }

    // ✅ Special handling for parent phone
    if (name === "parents_data.phone") {
      const cleaned = value.replace(/[^0-9]/g, ""); // Only digits
      setFormData((prev) => ({
        ...prev,
        parents_data: {
          ...prev.parents_data,
          phone: cleaned,
        },
      }));
      return;
    }
    // Special case for dob
    if (name === "dob") {
      const birthDate = new Date(value);
      const today = new Date();
      let calculatedAge = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        calculatedAge--;
      }

      setAge(calculatedAge);
    }

    // Nested parent_data fields
    if (name.startsWith("parents_data.")) {
      const key = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        parents_data: {
          ...prev.parents_data,
          [key]: type === "checkbox" ? checked : value,
        },
      }));
      return;
    }

    let updatedValue = value;
    if (name === "first_name" || name === "last_name") {
      // Allow only letters and spaces
      if (/^[a-zA-Z\s]*$/.test(value)) {
        updatedValue = value;
      } else {
        return; // Ignore invalid characters
      }
    }
    // Default update
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;

    if (name.endsWith("phone")) {
      let digitsOnly = value.replace(/\D/g, ""); // Only digits

      // Determine allowed length
      const maxLength = digitsOnly.startsWith("0") ? 10 : 9;
      if (digitsOnly.length > maxLength) {
        digitsOnly = digitsOnly.slice(0, maxLength);
      }

      if (name.includes(".")) {
        // Handle nested field e.g., parents_data.phone
        const [parentKey, childKey] = name.split(".");
        setFormData((prev) => ({
          ...prev,
          [parentKey]: {
            ...prev[parentKey],
            [childKey]: digitsOnly,
          },
        }));
      } else {
        // Flat field (e.g., phone)
        setFormData((prev) => ({
          ...prev,
          [name]: digitsOnly,
        }));
      }

      return;
    }

    // Other field types
    if (name.includes(".")) {
      const [parentKey, childKey] = name.split(".");
      setFormData((prev) => ({
        ...prev,
        [parentKey]: {
          ...prev[parentKey],
          [childKey]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleCategoryChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      category: selected ? selected.value : "",
      subcategory: "", // reset subcategory when category changes
    }));

    const subcats =
      selected?.subcategories?.map((sub) => ({
        label: sub.title,
        value: sub._id,
      })) || [];
    setSubcategoryOptions(subcats);
  };


  const handleFileUpload = (e, fieldName) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      [fieldName]: file,
    }));
  };
  const handleCountryChange = (selectedOption) =>
    setFormData((prev) => ({ ...prev, country: selectedOption }));
  const errors = {};
  const requiredFields = validationRules[currentStage] || [];
  requiredFields.forEach((field) => {
    if (
      !formData[field] ||
      (typeof formData[field] === "string" && !formData[field].trim())
    ) {
      errors[field] = "This field is required";
    }
  });
  const handleSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFormData((prev) => ({
      ...prev,
      languages: selectedValues,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateCurrentStage()) return;
    setIsLoader(true);
    try {
      const formDataToSend = new FormData();
      const stripLeadingZero = (number) =>
        number?.startsWith("0") ? number.slice(1) : number;

      formDataToSend.append("first_name", formData.first_name);
      formDataToSend.append("last_name", formData.last_name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("password", formData.password);
      if (formData.phone) {
        formDataToSend.append(
          "phone",
          `971${stripLeadingZero(formData.phone)}`,
        );
      }
      formDataToSend.append("country", formData.country || "");
      formDataToSend.append("nationality", formData.nationality || "");
      // formDataToSend.append("terms", formData.terms);

      // Calculate age from birth date
      if (formData.dob) {
        const birthDate = new Date(formData.dob);
        const age = new Date().getFullYear() - birthDate.getFullYear();
        formDataToSend.append("age", age);
      }
      const subSkillIds =
        Array.isArray(formData.subcategory) && formData.subcategory.length > 0
          ? formData.subcategory.map((sub) => sub.value).join(",") // use .value from select
          : "";

      formDataToSend.append("sub_skill_ids", formData.subcategory || "");
      formDataToSend.append("skill_id", formData.category || "");
      formDataToSend.append("weight", formData.weight);
      formDataToSend.append("height", formData.height);
      formDataToSend.append("languages", formData.languages.join(","));

      // // Bank details
      // formDataToSend.append("bank_details[account_holder]", formData.account_holder|| "");
      // formDataToSend.append("bank_details[iban]", formData.iban_number  || "");
      if (formData.picture) {
        formDataToSend.append("picture", formData.picture);
      }

      // formDataToSend.append("parents_data[name]", formData.iban_number  || "");
      // formDataToSend.append("parents_data[phone]", formData.iban_number  || "");
      // formDataToSend.append("parents_data[phone]", formData.iban_number  || "");
      // formDataToSend.append("parents_data[passport]", formData.iban_number  || "");

      formDataToSend.append("previous_works", formData.social_links || "");

      // previousWorksArray.forEach((link, index) => {
      //   formDataToSend.append(`previous_works`, formData.previous_work_links);
      // });
      // Files
      if (formData.passport) {
        formDataToSend.append("passport", formData.passport);
      }

      formDataToSend.append(
        "check_validation",
        currentStage === 3 ? false : true,
      );
      if (formData.emirates_id_document) {
        formDataToSend.append(
          "emirate_id[front]",
          formData.emirates_id_document,
        );
        formDataToSend.append(
          "emirate_id[back]",
          formData.emirates_id_document,
        );
      }

      if (formData.resume) {
        formDataToSend.append("resume", formData.resume);
      }

      if (age < 18) {
        formDataToSend.append("parents_data[name]", formData.parents_data.name);
        if (formData.parents_data?.phone) {
          formDataToSend.append(
            "parents_data[phone]",
            `971${stripLeadingZero(formData.parents_data.phone)}`,
          );
        }
        if (formData.parents_data.emirates_id_document) {
          formDataToSend.append(
            "parents_data[emirate_id][front]",
            formData.parents_data.emirates_id_document,
          );
          formDataToSend.append(
            "parents_data[emirate_id][back]",
            formData.parents_data.emirates_id_document,
          );
        }
        if (formData.parents_data.passport) {
          formDataToSend.append(
            "parents_data[passport]",
            formData.parents_data.passport,
          );
        }
      }

      const response = await ApiService.request({
        method: "POST",
        url: "/register",
        data: formDataToSend,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const data = response.data;
      console.log(data);
      if (data.status === false) {
        toast.error(data.message || "Something went wrong!");
        setIsLoader(false);
        return;
      }
      if (data.status === true && currentStage === 3) {
        toast.success(data.message);

        const talent_id = data.data?.talent?._id;
        const authToken = data.data?.talent?.auth_token;

        console.log("talent_id", talent_id);

        localStorage.setItem("talent_id", talent_id);
        localStorage.setItem("auth_token", authToken);
        localStorage.setItem("user", JSON.stringify(data.data?.talent));
        localStorage.setItem(
          "phone",
          data.data?.talent?.phone || formData.phone,
        );

        navigate("/talent/verify-otp");
      }
      setIsLoader(false);
      return true;
    } catch (error) {
      console.log(error.message);
      toast.error(error.message || "Registration failed!");
      setIsLoader(false);
      return false;
    }
  };

  const handleSubcategoryChange = (selected) => {
    // Save the selected data in formData for validation
    const selectedData = selected.map((option) => ({
      _id: option.value,
      title: option.label,
    }));

    setFormData((prev) => ({
      ...prev,
      subcategory: selectedData, // store selected objects
    }));
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //   const validateCurrentStage = () => {
  //     let newErrors = {};

  //     if (currentStage === 1) {
  //       if (!formData.first_name?.trim()) newErrors.first_name =  t("first_name_required");
  //       if (!formData.last_name?.trim()) newErrors.last_name =  t("last_name_required");
  //       if (!formData.dob) newErrors.dob = t("dob_required");
  //   if (!formData.email?.trim()) {
  //         newErrors.email = t("email_required");
  //       } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
  //         newErrors.email = t("email_invalid");;
  //       }

  //       if (!formData.phone?.trim()) {
  //         newErrors.phone = t("phone_required");
  //       } else if (!/^\d{7,15}$/.test(formData.phone.replace(/\D/g, ""))) {
  //         newErrors.phone =  t("phone_invalid");
  //       }
  //       if (!formData.category?.trim()) newErrors.category = t("skill_required");
  //   if (!formData.subcategory?.trim()) newErrors.subcategory = t("subskill_required");
  //   if (!formData.password?.trim()) newErrors.password = t("password_required");
  //       else if (formData.password.length < 6) newErrors.password = t("password_length");

  //     // Spoken languages validation
  //     if (!formData.languages || formData.languages.length === 0) {
  //       newErrors.languages = t("languages_required");
  //                 if (!formData.height?.trim()) newErrors.height = "Height is required";
  //     if (!formData.weight?.trim()) newErrors.weight = "Weight is required";
  //     }
  //     }

  //     if (currentStage === 2) {
  //           if (!formData.country?.trim()) newErrors.country = "Country is required";
  //           if (!formData.social_accounts?.instagram?.trim())
  //     newErrors["social_accounts.instagram"] = "Instagram link is required";

  //   if (!formData.social_accounts?.tiktok?.trim())
  //     newErrors["social_accounts.tiktok"] = "TikTok link is required";

  //   // if (!formData.social_accounts?.twitter?.trim())
  //   //   newErrors["social_accounts.twitter"] = "Twitter link is required";

  //   // ✅ Previous Work Links
  //   if (!formData.previous_work_links?.trim())
  //     newErrors.previous_work_links = "Previous work links are required";
  //  if (!formData.height?.trim()) newErrors.height = "Height is required";
  //     if (!formData.weight?.trim()) newErrors.weight = "Weight is required";
  // if (age < 18) {
  //         if (!formData.parents_data?.name?.trim()) newErrors["parents_data.name"] = "Parent name is required";
  //         if (!formData.parents_data?.phone?.trim()) newErrors["parents_data.phone"] = "Parent phone is required";
  //       }
  //     }

  //     if (currentStage === 3) {
  //       // File fields
  //       // if (!formData.emirates_id) newErrors.emirates_id = "Emirates ID is required";

  //       // Bank info
  //       // if (!formData.bank_name?.trim()) newErrors.bank_name = "Bank name is required";
  //       // if (!formData.account_holder?.trim()) newErrors.account_holder = "Account holder is required";
  //       // if (!formData.account_number?.trim()) newErrors.account_number = "Account number is required";
  //       // if (!formData.iban_number?.trim()) newErrors.iban_number = "IBAN number is required";

  //       // Password

  //       if (!formData.picture) newErrors.picture = "Photo is required";
  //       if (!formData.passport) newErrors.passport = "Passport is required";
  //   if (!formData.emirate_id_front) newErrors.emirate_id_front = "Emirates ID front is required";
  //   if (!formData.emirate_id_back) newErrors.emirate_id_back = "Emirates ID back is required";
  //   if (!formData.resume) newErrors.resume = "Resume is required";
  //       if (age < 18) {
  // if (!formData.parents_data.emirate_id_front) {
  //   newErrors["parents_data.emirate_id_front"] = "Parent Emirates ID front is required";
  // }
  // if (!formData.parents_data.emirate_id_back) {
  //   newErrors["parents_data.emirate_id_back"] = "Parent Emirates ID back is required";
  // }        if (!formData.parents_data?.passport) newErrors["parents_data.passport"] = "Parent Passport is required";
  //       }

  //       // Terms checkbox
  //       if (!formData.terms) newErrors.terms = "You must agree to the terms";
  //     }

  //     setFormErrors(newErrors);
  //     return Object.keys(newErrors).length === 0;
  //   };

  const validateCurrentStage = () => {
    let newErrors = {};

    if (currentStage === 1) {
      if (!formData.first_name?.trim())
        newErrors.first_name = t("first_name_required");
      if (!formData.last_name?.trim())
        newErrors.last_name = t("last_name_required");
      if (!formData.dob) newErrors.dob = t("dob_required");
      if (!formData.email?.trim()) {
        newErrors.email = t("email_required");
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = t("email_invalid");
      }

      if (!formData.phone?.trim()) {
        newErrors.phone = t("phone_required");
      } else if (!/^\d{7,15}$/.test(formData.phone.replace(/\D/g, ""))) {
        newErrors.phone = t("phone_invalid");
      }
      if (!formData.category?.trim()) newErrors.category = t("skill_required");
      if (!formData.subcategory?.trim())
        newErrors.subcategory = t("subskill_required");
      if (!formData.password?.trim())
        newErrors.password = t("password_required");
      else if (formData.password.length < 6)
        newErrors.password = t("password_length");

      // Spoken languages validation
      if (!formData.languages || formData.languages.length === 0) {
        newErrors.languages = t("languages_required");
      }
    }

    if (currentStage === 2) {
      if (!formData.height?.trim()) newErrors.height = t("height_required");
      if (!formData.weight?.trim()) newErrors.weight = t("weight_required");
      if (!formData.country?.trim()) newErrors.country = t("country_required");

      if (!formData.height?.trim()) newErrors.height = t("height_required");
      if (!formData.weight?.trim()) newErrors.weight = t("weight_required");

      if (age < 18) {
        if (!formData.parents_data?.name?.trim())
          newErrors["parents_data.name"] = t("parent_name_required");
        if (!formData.parents_data?.phone?.trim())
          newErrors["parents_data.phone"] = t("parent_phone_required");
      }
    }

    if (currentStage === 3) {
      // File fields
      // if (!formData.emirates_id) newErrors.emirates_id = "Emirates ID is required";

      // Bank info
      // if (!formData.bank_name?.trim()) newErrors.bank_name = "Bank name is required";
      // if (!formData.account_holder?.trim()) newErrors.account_holder = "Account holder is required";
      // if (!formData.account_number?.trim()) newErrors.account_number = "Account number is required";
      // if (!formData.iban_number?.trim()) newErrors.iban_number = "IBAN number is required";

      // Password

      if (!formData.picture) newErrors.picture = t("photo_required");
      if (!formData.passport) newErrors.passport = t("passport_required");
      if (!formData.emirates_id_document)
        newErrors.emirates_id_document = t("emirates_id_front_required");
      if (!formData.resume) newErrors.resume = t("resume_required");

      if (age < 18) {
        if (!formData.parents_data.emirates_id_document) {
          newErrors["parents_data.emirates_id_document"] = t(
            "parent_emirates_id_front_required",
          );
        }
        if (!formData.parents_data?.passport)
          newErrors["parents_data.passport"] = t("parent_passport_required");
      }

      // Terms checkbox
      if (!formData.terms) newErrors.terms = t("terms_required");
    }

    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  console.log(formData.subcategory);
  const handleNext = async (e) => {
    e.preventDefault();

    if (!validateCurrentStage()) return;

    // Only go to next step if handleSubmit succeeds
    const success = await handleSubmit(e);
    if (!success) return;

    if (currentStage < totalStages) {
      setCurrentStage((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentStage > 1) {
      setCurrentStage((prev) => prev - 1);
    }
  };

  const truncateFileName = (name, maxChars = 5) => {
    if (!name) return "No file selected";
    return name.length > maxChars ? name.slice(0, maxChars) + "..." : name;
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData((prev) => ({
      ...prev,
      photos: files,
    }));
  };
  const uploadButtonStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 18px",
    borderRadius: "8px",
    backgroundColor: "#FF6237",
    color: "#fff",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    border: "none",
  };

  return (
    <AuthTalentGuard>
      <Header />

      <div className="position-relative min-vh-100 d-flex flex-column main-bg">
        <Container fluid className="inter-font py-3  ">
          <Row className="inter-font align-items-center justify-content-center">
            {/* <Link
            to={"/"}
            xs={12}
            md={1}
            className="col inter-font text-center text-md-start mb-3 mb-md-0 cursor-pointer"
          >
            <img src={logo} alt="Logo" style={{ height: "50px" }} />
          </Link> */}
            <Col xs={12} className="inter-font text-center">
              <div className="inter-font d-flex flex-md-row align-items-center justify-content-center gap-2">
                <div className="inter-font d-flex align-items-center justify-content-center">
                  <Step active={currentStage === 1}>1</Step>
                  <span
                    className="inter-font sofia-font fs-count"
                    style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}
                  >
                    {t("t_reg_s1_setp1")}
                  </span>
                </div>
                <Arrow />
                <div className="inter-font d-flex align-items-center justify-content-center">
                  <Step active={currentStage === 2}>2</Step>
                  <span
                    className="inter-font sofia-font fs-count"
                    style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}
                  >
                    {t("t_reg_s1_setp2")}
                  </span>
                </div>
                <Arrow />
                <div className="inter-font d-flex align-items-center justify-content-center">
                  <Step active={currentStage === 3}>3</Step>
                  <span
                    className="inter-font sofia-font fs-count"
                    style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}
                  >
                    {t("t_reg_s1_setp3")}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="flex-grow-1  d-flex justify-content-center align-items-center px-3 company-registration-form">
          <form
            className="inter-font bg-white p-4 rounded-4 shadow talent-reg-form w-100"
            style={{ maxWidth: "605px" }}
            onSubmit={handleSubmit}
          >
            <div className="inter-font d-flex flex-column justify-content-center align-items-center">
              <h2
                className="inter-font inter-font mb-3"
                style={{ fontSize: "25px" }}
              >
                {t("t_reg_s1_title")}
              </h2>
              {currentStage === 1 && (
                <>
                  {/* First & Last Name */}
                  <div className="inter-font row w-100">
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text8")} {/* First Name */}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="first_name"
                        placeholder={t("t_d_text9")}
                        className="inter-font p-2 rounded-2 w-100 fw-light border-1 form-control"
                        value={formData.first_name}
                        onChange={handleChange}
                        required
                        style={{
                          backgroundColor: "#f8f8f8",
                          textAlign: isRTL ? "right" : "left",
                        }}
                        dir="ltr"
                      />
                      {formErrors.first_name && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.first_name}
                        </small>
                      )}
                    </div>
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text10")} <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="last_name"
                        placeholder={t("t_d_text11")}
                        className="inter-font p-2 rounded-2 w-100 fw-light border-1 form-control"
                        value={formData.last_name}
                        onChange={handleChange}
                        required
                        style={{
                          backgroundColor: "#f8f8f8",
                          textAlign: isRTL ? "right" : "left",
                        }}
                        dir="ltr"
                      />
                      {formErrors.last_name && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.last_name}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="inter-font row w-100">
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("c_ff_text30")} {/* Email */}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="inter-font p-2 rounded-2 w-100 border-1 form-control"
                        placeholder={t("c_ff_text3")}
                        value={formData.email}
                        onChange={handleChange}
                        required
                        style={{
                          backgroundColor: "#f8f8f8",
                          textAlign: isRTL ? "right" : "left",
                        }}
                        dir="ltr"
                      />
                      {formErrors.email && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.email}
                        </small>
                      )}
                    </div>

                    {/* Phone */}
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("h_text5")} {/* Phone Number */}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <InputGroupWithFlag
                        placeholder="52 123 4567"
                        name="phone"
                        value={formData.phone}
                        onChange={handlePhoneChange}
                        className="inter-font p-2 rounded-2 w-100 form-control"
                      />
                      {formErrors.phone && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.phone}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="inter-font row w-100">
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("c_ff_text2")} {/* Password */}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <div className="inter-font position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className="inter-font p-2 rounded-2 w-100 pe-5 border-1 form-control"
                          placeholder={t("new_text_17")}
                          value={formData.password}
                          onChange={handleChange}
                          required
                          style={{
                            backgroundColor: "#f8f8f8",
                            textAlign: isRTL ? "right" : "left",
                          }}
                          dir="ltr"
                        />
                        <span
                          onClick={togglePasswordVisibility}
                          style={{
                            position: "absolute",
                            [isRTL ? "left" : "right"]: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#aaa",
                          }}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                      </div>
                      {formErrors.password && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.password}
                        </small>
                      )}
                    </div>

                    {/* DOB */}
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text13")} {/* Date of Birth */}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        name="dob"
                        className="inter-font p-2 rounded-2 w-100 border-1 form-control"
                        value={formData.dob}
                        onChange={handleChange}
                        required
                        style={{ backgroundColor: "#f8f8f8" }}
                        max={new Date().toISOString().split("T")[0]} // No future date
                      />
                      {formErrors.dob && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.dob}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="inter-font row w-100">
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text41")} {/* Skill */}
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={[...categoryOptions].sort((a, b) =>
                          a.label.localeCompare(b.label),
                        )}
                        value={selectedCategory}
                        placeholder={t("select_skill_placeholder")}
                        onChange={(option) => {
                          setSelectedCategory(option);
                          setFormData((prev) => ({
                            ...prev,
                            category: option ? option.value : "",
                          }));
                        }}
                        styles={customStyles}
                      />
                      {formErrors.category && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.category}
                        </small>
                      )}
                    </div>

                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text42")} {/* Subskill */}
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        isMulti
                        options={[...subcategoryOptions].sort((a, b) =>
                          a.label.localeCompare(b.label),
                        )}
                        value={selectedSubcategory || []}
                        onChange={(selected) => {
                          setSelectedSubcategory(selected);
                          setFormData((prev) => ({
                            ...prev,
                            subcategory:
                              selected.length > 0
                                ? selected.map((opt) => opt.value).join(",")
                                : "",
                          }));
                        }}
                        placeholder={t("select_subskills_placeholder")}
                        styles={customStyles}
                      />
                      {formErrors.subcategory && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.subcategory}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="inter-font row w-100">
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text16")} {/* Spoken Languages */}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        isMulti
                        name="languages"
                        options={languageOptions}
                        onChange={handleSelectChange}
                        value={languageOptions.filter((option) =>
                          formData.languages.includes(option.value),
                        )}
                        placeholder={t("select_languages_placeholder")}
                        styles={customStyles}
                      />
                      {formErrors.languages && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.languages}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              {currentStage === 2 && (
                <>
                  <div className="inter-font mb-3 w-100">
                    <label style={{ textAlign: isRTL ? "right" : "left" }}>
                      {t("country")} {/* Country */}{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <Select
                      options={[...nationalityOptions].sort((a, b) =>
                        a.label.localeCompare(b.label),
                      )}
                      components={{ Option, SingleValue }}
                      value={nationalityOptions.find(
                        (option) => option.value === formData.country,
                      )}
                      onChange={(selectedOption) =>
                        setFormData((prev) => ({
                          ...prev,
                          country: selectedOption ? selectedOption.value : "",
                          nationality: selectedOption
                            ? selectedOption.nationality
                            : "",
                        }))
                      }
                      placeholder={t("select_country")}
                      className="inter-font"
                      classNamePrefix="react-select"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          height: "44px",
                          minHeight: "44px",
                          fontSize: "14px",
                          backgroundColor: "#f8f8f8",
                          borderRadius: "8px",
                          borderColor: "#ced4da",
                          boxShadow: state.isFocused
                            ? "0 0 0 1px #cd496d"
                            : "none",
                          "&:hover": { borderColor: "#cd496d" },
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "44px",
                          padding: "0 12px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0px",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#6c757d",
                          fontSize: "14px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: "#212529",
                          fontSize: "14px",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          borderRadius: "8px",
                          zIndex: 9999,
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? "#f1f1f1" : "#fff",
                          color: "#212529",
                          cursor: "pointer",
                          padding: "8px 10px",
                          fontSize: "14px",
                        }),
                      }}
                    />
                    {formErrors.country && (
                      <small
                        className="text-danger"
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {formErrors.country}
                      </small>
                    )}
                  </div>

                  <div className="inter-font row w-100">
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text14")} {/* Height (cm) */}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        name="height"
                        className="inter-font p-2 rounded-2 w-100 border-1 form-control"
                        placeholder={t("t_d_text14")}
                        value={formData.height}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f8f8f8",
                          textAlign: isRTL ? "right" : "left",
                        }}
                        dir="ltr"
                      />
                      {formErrors.height && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.height}
                        </small>
                      )}
                    </div>
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("t_d_text15")} {/* Weight (kg) */}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        name="weight"
                        className="inter-font p-2 rounded-2 w-100 border-1 form-control"
                        placeholder={t("t_d_text15")}
                        value={formData.weight}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f8f8f8",
                          textAlign: isRTL ? "right" : "left",
                        }}
                        dir="ltr"
                      />
                      {formErrors.weight && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.weight}
                        </small>
                      )}
                    </div>
                  </div>

                  {age < 18 && (
                    <div className="inter-font row w-100">
                      {/* Parent Name */}
                      <div
                        className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                        style={{
                          [isRTL ? "paddingRight" : "paddingLeft"]: "0",
                        }}
                      >
                        <label style={{ textAlign: isRTL ? "right" : "left" }}>
                          {t("t_d_text34")} {/* Parent Name */}{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="parents_data.name"
                          className="inter-font p-2 rounded-2 w-100 border-1 form-control"
                          value={formData.parents_data?.name || ""}
                          onChange={handleChange}
                          placeholder={t("t_d_text35")}
                          style={{
                            backgroundColor: "#f8f8f8",
                            textAlign: isRTL ? "right" : "left",
                          }}
                          dir="ltr"
                        />
                        {formErrors["parents_data.name"] && (
                          <small
                            className="text-danger"
                            style={{ textAlign: isRTL ? "right" : "left" }}
                          >
                            {formErrors["parents_data.name"]}
                          </small>
                        )}
                      </div>

                      {/* Parent Phone */}
                      <div
                        className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                        style={{
                          [isRTL ? "paddingRight" : "paddingLeft"]: "0",
                        }}
                      >
                        <label style={{ textAlign: isRTL ? "right" : "left" }}>
                          {t("t_d_text36")} {/* Parent Phone */}{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <InputGroupWithFlag
                          placeholder="52 123 4567"
                          name="parents_data.phone"
                          value={formData.parents_data?.phone || ""}
                          onChange={handlePhoneChange}
                          className="inter-font p-2 rounded-2 w-100 form-control"
                        />
                        {formErrors["parents_data.phone"] && (
                          <small
                            className="text-danger"
                            style={{ textAlign: isRTL ? "right" : "left" }}
                          >
                            {formErrors["parents_data.phone"]}
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Social Media Accounts */}
                  <div className="inter-font row w-100">
                    <div
                      className="inter-font col-12 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("social_previous_links")}
                      </label>
                      <input
                        type="text"
                        name="social_links"
                        className="inter-font p-2 rounded-2 w-100 border-1 form-control"
                        placeholder={t("social_previous_links_placeholder")}
                        value={formData.social_links}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f8f8f8",
                          textAlign: isRTL ? "right" : "left",
                        }}
                        dir="ltr"
                      />
                    </div>
                  </div>
                </>
              )}

              {currentStage === 3 && (
                <>
                  <div className="inter-font row w-100">
                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("new_text_81")}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <div className="d-flex align-items-center">
                        <input
                          type="file"
                          id="photoUpload"
                          name="picture"
                          accept="image/*"
                          className="form-control"
                          style={{ display: "none" }}
                          onChange={handleChange}
                        />

                        <div className="d-flex align-items-center gap-2">
                          <label
                            htmlFor="photoUpload"
                            className="btn upload-btn"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "10px 18px",
                              borderRadius: "8px",
                              backgroundColor: "#FF6237",
                              color: "#fff",
                              fontWeight: "500",
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                              border: "none",
                              gap: "8px",
                            }}
                          >
                            <i className="bi bi-upload"></i> {t("select_file")}
                          </label>

                          <span
                            className="small text-muted"
                            style={{ textAlign: isRTL ? "right" : "left" }}
                          >
                            {formData.picture?.name
                              ? truncateFileName(formData.picture.name)
                              : t("no_file_selected")}
                          </span>
                        </div>
                      </div>
                      <small
                        className="text-muted d-block mt-1"
                        style={{
                          textAlign: isRTL ? "right" : "left",
                          fontSize: "11px",
                        }}
                      >
                        {t("photo_requirements")}
                      </small>
                      {formErrors.picture && (
                        <small
                          className="text-danger d-block"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.picture}
                        </small>
                      )}
                    </div>

                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("passport")} <span className="text-danger">*</span>
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="file"
                          id="passport"
                          name="passport"
                          style={{ display: "none" }}
                          onChange={handleChange}
                        />

                        <label
                          htmlFor="passport"
                          className="btn upload-btn"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "10px 18px",
                            borderRadius: "8px",
                            backgroundColor: "#FF6237",
                            color: "#fff",
                            fontWeight: "500",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            border: "none",
                            gap: "8px",
                          }}
                        >
                          <i className="bi bi-upload"></i> {t("select_file")}
                        </label>

                        <span
                          className="small text-muted"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formData.passport?.name
                            ? truncateFileName(formData.passport.name)
                            : t("no_file_selected")}
                        </span>
                      </div>
                      <small
                        className="text-muted d-block mt-1"
                        style={{
                          textAlign: isRTL ? "right" : "left",
                          fontSize: "11px",
                        }}
                      >
                        {t("document_requirements")}
                      </small>
                      {formErrors.passport && (
                        <small
                          className="text-danger d-block"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.passport}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="inter-font row w-100">
                    <div
                      className="inter-font col-12 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("emirates_id_front")}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="file"
                          id="emiratesIdDocument"
                          name="emirates_id_document"
                          accept="image/*,application/pdf"
                          style={{ display: "none" }}
                          onChange={handleChange}
                        />
                        <label
                          htmlFor="emiratesIdDocument"
                          className="btn upload-btn"
                          style={{ ...uploadButtonStyle, gap: "8px" }}
                        >
                          <i className="bi bi-upload"></i> {t("select_file")}
                        </label>
                        <span
                          className="small text-muted"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formData.emirates_id_document?.name
                            ? truncateFileName(
                                formData.emirates_id_document.name,
                              )
                            : t("no_file_selected")}
                        </span>
                      </div>
                      <small
                        className="text-muted d-block mt-1"
                        style={{
                          textAlign: isRTL ? "right" : "left",
                          fontSize: "11px",
                        }}
                      >
                        {t("document_requirements")}
                      </small>
                      {formErrors.emirates_id_document && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.emirates_id_document}
                        </small>
                      )}
                    </div>
                  </div>

                  {age < 18 && (
                    <div className="inter-font row w-100">
                      <div
                        className="inter-font col-12 d-flex flex-column mb-3"
                        style={{
                          [isRTL ? "paddingRight" : "paddingLeft"]: "0",
                        }}
                      >
                        <label style={{ textAlign: isRTL ? "right" : "left" }}>
                          {t("parent_emirates_id_front")}{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="d-flex align-items-center gap-2">
                          <input
                            type="file"
                            id="parentEmiratesIdDocument"
                            name="parents_data.emirates_id_document"
                            accept="image/*,application/pdf"
                            style={{ display: "none" }}
                            onChange={handleChange}
                          />

                          <label
                            htmlFor="parentEmiratesIdDocument"
                            className="btn upload-btn"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "10px 18px",
                              borderRadius: "8px",
                              backgroundColor: "#FF6237",
                              color: "#fff",
                              fontWeight: "500",
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                              border: "none",
                              gap: "8px",
                            }}
                          >
                            <i className="bi bi-upload"></i> {t("select_file")}
                          </label>

                          <span
                            className="small text-muted"
                            style={{ textAlign: isRTL ? "right" : "left" }}
                          >
                            {formData.parents_data?.emirates_id_document?.name
                              ? truncateFileName(
                                  formData.parents_data.emirates_id_document
                                    .name,
                                )
                              : t("no_file_selected")}
                          </span>
                        </div>
                        <small
                          className="text-muted d-block mt-1"
                          style={{
                            textAlign: isRTL ? "right" : "left",
                            fontSize: "11px",
                          }}
                        >
                          {t("document_requirements")}
                        </small>
                        {formErrors["parents_data.emirates_id_document"] && (
                          <small
                            className="text-danger d-block"
                            style={{ textAlign: isRTL ? "right" : "left" }}
                          >
                            {formErrors["parents_data.emirates_id_document"]}
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="inter-font row w-100">
                    {age < 18 && (
                      <div
                        className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                        style={{
                          [isRTL ? "paddingRight" : "paddingLeft"]: "0",
                        }}
                      >
                        <label style={{ textAlign: isRTL ? "right" : "left" }}>
                          {t("parent_passport")}{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="d-flex align-items-center gap-2">
                          <input
                            type="file"
                            id="parentPassport"
                            name="parents_data.passport"
                            style={{ display: "none" }}
                            onChange={handleChange}
                          />

                          <label
                            htmlFor="parentPassport"
                            className="btn upload-btn"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "10px 18px",
                              borderRadius: "8px",
                              backgroundColor: "#FF6237",
                              color: "#fff",
                              fontWeight: "500",
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                              border: "none",
                              gap: "8px",
                            }}
                          >
                            <i className="bi bi-upload"></i> {t("select_file")}
                          </label>

                          <span
                            className="small text-muted"
                            style={{ textAlign: isRTL ? "right" : "left" }}
                          >
                            {formData.parents_data?.passport?.name
                              ? truncateFileName(
                                  formData.parents_data.passport.name,
                                )
                              : t("no_file_selected")}
                          </span>
                        </div>
                        <small
                          className="text-muted d-block mt-1"
                          style={{
                            textAlign: isRTL ? "right" : "left",
                            fontSize: "11px",
                          }}
                        >
                          {t("document_requirements")}
                        </small>
                        {formErrors["parents_data.passport"] && (
                          <small
                            className="text-danger d-block"
                            style={{ textAlign: isRTL ? "right" : "left" }}
                          >
                            {formErrors["parents_data.passport"]}
                          </small>
                        )}
                      </div>
                    )}

                    <div
                      className="inter-font col-12 col-md-6 d-flex flex-column mb-3"
                      style={{ [isRTL ? "paddingRight" : "paddingLeft"]: "0" }}
                    >
                      <label style={{ textAlign: isRTL ? "right" : "left" }}>
                        {t("upload_resume")}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="file"
                          id="resumeUpload"
                          name="resume"
                          accept=".pdf,.doc,.docx"
                          style={{ display: "none" }}
                          onChange={handleChange}
                        />
                        <label
                          htmlFor="resumeUpload"
                          className="btn upload-btn"
                          style={{ ...uploadButtonStyle, gap: "8px" }}
                        >
                          <i className="bi bi-upload"></i> {t("select_file")}
                        </label>
                        <span
                          className="small text-muted"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formData.resume?.name
                            ? truncateFileName(formData.resume.name)
                            : t("no_file_selected")}
                        </span>
                      </div>
                      <small
                        className="text-muted d-block mt-1"
                        style={{
                          textAlign: isRTL ? "right" : "left",
                          fontSize: "11px",
                        }}
                      >
                        {t("resume_requirements")}
                      </small>
                      {formErrors.resume && (
                        <small
                          className="text-danger"
                          style={{ textAlign: isRTL ? "right" : "left" }}
                        >
                          {formErrors.resume}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="inter-font mb-0 w-100 mt-3">
                    <div
                      className="inter-font d-flex align-items-start"
                      style={{
                        flexDirection: isRTL ? "row-reverse" : "row",
                        gap: "8px",
                      }}
                    >
                      <input
                        type="checkbox"
                        name="terms"
                        className="inter-font"
                        style={{ marginTop: "2px" }}
                        checked={formData.terms}
                        onChange={handleChange}
                        required
                      />
                      <span
                        className="inter-font sofia-font text-size"
                        style={{
                          fontSize: "14px",
                          textAlign: isRTL ? "right" : "left",
                        }}
                      >
                        {t("agree_terms")}
                        <span
                          className="inter-font text-decoration-underline"
                          style={{
                            color: "rgb(255, 98, 55)",
                            cursor: "pointer",
                            marginLeft: isRTL ? "0" : "4px",
                            marginRight: isRTL ? "4px" : "0",
                          }}
                        >
                          <Link
                            to="/privacy-policy"
                            style={{
                              color: "rgb(255, 98, 55)",
                              cursor: "pointer",
                            }}
                          >
                            {t("privacy_policy")}
                          </Link>
                          ,{" "}
                          <Link
                            to="/terms-and-conditions"
                            style={{
                              color: "rgb(255, 98, 55)",
                              cursor: "pointer",
                            }}
                          >
                            {t("terms_condition")}
                          </Link>
                        </span>
                      </span>
                    </div>
                    {formErrors.terms && (
                      <small
                        className="text-danger"
                        style={{ textAlign: isRTL ? "right" : "left" }}
                      >
                        {formErrors.terms}
                      </small>
                    )}
                  </div>
                </>
              )}
              <div className="inter-font text-center mt-4 w-100 d-flex justify-content-center gap-3">
                {currentStage > 1 && (
                  <button
                    type="button"
                    onClick={handlePrev}
                    className="inter-font btn btn-base w-100"
                    style={{ maxWidth: "270px", height: "50px" }}
                  >
                    {t("back")}
                  </button>
                )}

                <button
                  type="submit"
                  onClick={
                    currentStage === totalStages ? handleSubmit : handleNext
                  }
                  className="inter-font btn btn-base w-100"
                  style={{ maxWidth: "270px", height: "50px" }}
                  disabled={isLoader}
                >
                  {isLoader
                    ? t("processing")
                    : currentStage === totalStages
                      ? t("new_text_1")
                      : t("next")}
                </button>
              </div>

              <p
                className="inter-font mt-3 text-center sofia-font"
                style={{
                  fontSize: "15px",
                  textAlign: isRTL ? "right" : "left",
                }}
              >
                {t("already_have_account")}
                <Link
                  to="/talent/login"
                  className="inter-font sofia-font"
                  style={{
                    cursor: "pointer",
                    color: "#FF6237",
                    marginRight: isRTL ? "8px" : "0",
                    marginLeft: isRTL ? "0" : "8px",
                  }}
                  onClick={onSwitchToLogin}
                >
                  {t("sign_in")}
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </AuthTalentGuard>
  );
};

const InputGroupWithFlag = ({
  placeholder,
  name,
  value,
  onChange,
  isInvalid,
}) => (
  <div
    className={`inter-font d-flex form-control align-items-center border rounded ps-2 ${
      isInvalid ? "border-danger" : ""
    }`}
    style={{ direction: "ltr" }}
  >
    <img
      src={flag}
      alt="UAE"
      style={{ width: "25px", height: "18px", marginRight: "6px" }}
    />
    <span className="inter-font text-muted pe-2 inter-font">(+971)</span>
    <Form.Control
      type="text"
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      isInvalid={isInvalid}
      maxLength={value?.startsWith("0") ? 10 : 9}
      className="inter-font border-0 ps-1 sofia-font w-100 "
      style={{
        boxShadow: "none",
        height: "33px",
      }}
    />
  </div>
);

export default TalentRegistration;
